import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBrand } from "src/models/Products/Brand.models";

interface BrandState {
  brands: IBrand[];
  brandToEdit: IBrand | null;
}

const initialState: BrandState = {
  brands: [],
  brandToEdit: null,
};

const brandSlice = createSlice({
  name: "Brand",
  initialState,
  reducers: {
    setBrandList: (state, action: PayloadAction<IBrand[]>) => {
      state.brands = action.payload;
    },
    concatListBrand: (state: BrandState, action: PayloadAction<IBrand[]>) => {
      state.brands = [...state.brands.concat(action.payload)];
    },
    setBrandToEdit: (state, action: PayloadAction<IBrand | null>) => {
      state.brandToEdit = action.payload;
    },
    addBrand: (state, action: PayloadAction<IBrand>) => {
      state.brands.push(action.payload);
    },
    addBrands: (state, action: PayloadAction<IBrand[]>) => {
      state.brands.push(...action.payload);
    },
    updateBrand: (state, action: PayloadAction<IBrand>) => {
      let itemIndex = state.brands.findIndex(
        item => item.brandId === action.payload.brandId
      );
      if (itemIndex !== -1) state.brands[itemIndex] = action.payload;
    },
    deleteBrand: (state, action: PayloadAction<number>) => {
      const newArray = state.brands.filter(
        item => item.brandId !== action.payload
      );
      state.brands = newArray;
    },
  },
});

export const {
  setBrandList,
  concatListBrand,
  setBrandToEdit,
  addBrand,
  addBrands,
  updateBrand,
  deleteBrand,
} = brandSlice.actions;

export default brandSlice.reducer;
